import CLPViewState from '../store/schema/CLPViewState';
import CLPLabel from 'owa-mail-store/lib/store/schema/CLPLabel';
import getCLPLabelMethod from './getCLPLabelMethod';
import extendedPropertyType from 'owa-service/lib/factory/extendedPropertyType';
import extendedPropertyUri from 'owa-service/lib/factory/extendedPropertyUri';
import getUserConfiguration from 'owa-session-store/lib/actions/getUserConfiguration';
import Message from 'owa-service/lib/contract/Message';
import { now, getISOString } from 'owa-datetime';
import { logCLPComposeUsage } from '../utils/logCLPDatapoints';
import { LABEL_PROPERTY_NAME } from '../utils/constants';

const CLP_LABEL_PREFIX = 'MSIP_Label';

interface LabelStamp {
    Enabled: string;
    SiteId: string;
    SetDate: string;
    Name: string;
    ContentBits: number;
    Method: string;
}

export default function stampCLPLabelInExtendedProperty(clpViewState: CLPViewState, item: Message) {
    const tenantId = getUserConfiguration().SessionSettings.ExternalDirectoryTenantGuid;

    let { selectedCLPLabel, nonTenantLabelString } = clpViewState;

    if (!selectedCLPLabel && !nonTenantLabelString) {
        return;
    }

    let selectedLabelString = '';
    if (selectedCLPLabel) {
        const labelSetDate = getISOString(now());
        const labelNameToStamp = selectedCLPLabel.displayName;

        const labelStampObj: LabelStamp = {
            Enabled: 'True',
            SiteId: tenantId,
            SetDate: labelSetDate,
            Name: labelNameToStamp,
            ContentBits: 0,
            Method: getCLPLabelMethod(clpViewState),
        };
        selectedLabelString = getLabelStampString(labelStampObj, selectedCLPLabel);
    }

    let extendedProperty = extendedPropertyType({
        ExtendedFieldURI: extendedPropertyUri({
            PropertyName: LABEL_PROPERTY_NAME,
            DistinguishedPropertySetId: 'InternetHeaders',
            PropertyType: 'String',
        }),
        Value: nonTenantLabelString
            ? nonTenantLabelString + selectedLabelString
            : selectedLabelString,
    });

    if (item.ExtendedProperty) {
        item.ExtendedProperty.push(extendedProperty);
    } else {
        item.ExtendedProperty = [extendedProperty];
    }

    logCLPComposeUsage(selectedCLPLabel);
}

function getLabelStampString(labelStampObj: LabelStamp, selectedCLPLabel: CLPLabel): string {
    let stampString = '';
    stampString = Object.keys(labelStampObj)
        .map(key => {
            return `${CLP_LABEL_PREFIX}_${selectedCLPLabel.id}_${key}=${labelStampObj[key]};`;
        })
        .join('');
    return stampString;
}
